import { PARENT_ROUTE as ADMIN_PARENT_ROUTE } from './admin';

const PARENT_ROUTE = '/integrations';
const ADMIN_INTEGRATION_PARENT_ROUTE = `${ADMIN_PARENT_ROUTE}${PARENT_ROUTE}`;

// The integrations pages live in effy-fe's mgsa app (`/w`); only AI connections is served here.
const MGSA_ADMIN_INTEGRATIONS_ROUTE = '/w/admin/integrations';

const integrationsAdminRoutes = {
  IntegrationsManager: () => MGSA_ADMIN_INTEGRATIONS_ROUTE,
  AIConnectionsManager: () => `${ADMIN_INTEGRATION_PARENT_ROUTE}/ai-connections`,
  IntegrationsDetails: (integrationId: string) =>
    `${MGSA_ADMIN_INTEGRATIONS_ROUTE}/${integrationId}/details`,
  IntegrationsSettings: (integrationId: string) =>
    `${MGSA_ADMIN_INTEGRATIONS_ROUTE}/${integrationId}/settings`,
};

const routes = {
  ...integrationsAdminRoutes,
};

export const INTEGRATIONS_ADMIN_ROUTE_KEYS = {
  IntegrationsManager: 'IntegrationsManager',
  AIConnectionsManager: 'AIConnectionsManager',
  IntegrationsDetails: 'IntegrationsDetails',
  IntegrationsSettings: 'IntegrationsSettings',
};

export const INTEGRATIONS_LEARNER_ROUTE_KEYS = {};

export const INTEGRATIONS_ROUTE_KEYS = {
  ...INTEGRATIONS_ADMIN_ROUTE_KEYS,
  ...INTEGRATIONS_LEARNER_ROUTE_KEYS,
};

export default routes;
